import React from "react";
import { IoIosClose } from "react-icons/io";
import "../BannerPop/BannerPop.css";

const BannerPop = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleCall = () => {
    window.location.href = "tel:02039449931";
  };

  return (
    <div className="bannerpop-overlay">
      <div className="bannerpop-box">
        <IoIosClose className="bannerpop-close" onClick={onClose} />

        <img
          src="/banner1.webp"
          alt="Call Offer"
          className="bannerpop-image"
          onClick={handleCall}
        />
      </div>
    </div>
  );
};

export default BannerPop;
